<div class="my-3 mx-2 p-4">
    <div class="row">
        <div class="d-flex flex-column mb-4">
            <h2 class="sub-header-title">
                <div>
                    <span *ngIf="cancelReservation && !activeAndCancelledReservations">Cancel</span>
                    <span *ngIf="cancelReservation && activeAndCancelledReservations">Update</span>
                    <span *ngIf="!cancelReservation && !activeAndCancelledReservations">Uncancel</span>
                    Reservation<span *ngIf="selectedReservations.length > 1">s</span>
                </div>
            </h2>
        </div>
    </div>
    <div class="row my-3">
        <div class="col-12">
            <div class="d-flex flex-column">
                <div class="d-flex justify-content-start">
                    Are you sure you would like to proceed?
                </div>
            </div>
        </div>
    </div>
    <div class="row my-3" *ngIf="cancelReservation">
        <div class="d-flex flex-column col-6 sub-form-header-title my-3">
            <span>IDs: </span>
            <ng-container *ngFor="let reservation of selectedReservations">
                <span>{{ reservation.reservation_id }}</span>
            </ng-container>
        </div>
        <div class="d-flex flex-column col-6 my-3">
            <form [formGroup]="statusForm">
                <mat-form-field appearance="outline">
                    <mat-label>Cancel Date</mat-label>
                    <input matInput [matDatepicker]="picker" formControlName="cancel_date" >
                    <mat-hint>MM/DD/YYYY</mat-hint>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </form>
        </div>
    </div>
    <div class="mt-2 d-flex justify-content-end">
        <button mat-raised-button class="cancel-finish-button" (click)="cancelUpdateReservationStatus()">
            <mat-icon>cancel</mat-icon>
            Exit
        </button>
        <button *ngIf="!cancelReservation || activeAndCancelledReservations" mat-raised-button class="action-button" style="margin-right:8px" (click)="submitUpdateReservationStatus(false)">
            <mat-icon>add</mat-icon>
            Uncancel
        </button>
        <button *ngIf="cancelReservation || activeAndCancelledReservations" mat-raised-button class="warn-button" (click)="submitUpdateReservationStatus(true)">
            <mat-icon>delete</mat-icon>
            Confirm
        </button>
    </div>
</div>